import { render, staticRenderFns } from "./IconInfo2.vue?vue&type=template&id=13be0d59&scoped=true&"
import script from "./IconInfo2.vue?vue&type=script&lang=js&"
export * from "./IconInfo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be0d59",
  null
  
)

export default component.exports